import {RouterContextProvider} from './RouterContext'

const providersList = [
  RouterContextProvider,
  ];
  
  const ContextProvidersComponent = props => providersList.reduce((acc, Component: any) => (
    <Component>
      {acc}
    </Component>), props.children);
  
  export default ContextProvidersComponent;
